import React, { FC } from 'react'

interface Props {
    prefix: any
}

const LoadingLayout: FC<Props> = ({ prefix }) => {
    return (
        <div className="loader-wrapper">
            <div className="loader-body">
                <ul>
                    <li>
                        <div className="loader">
                            <div className="child" style={{ background: prefix.info?.themeColor?.primary }}></div>
                        </div>
                    </li>

                    <li>
                        <div className="text"></div>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default LoadingLayout
